import { Image } from '@apparel/core/models/Image';
import { OverrideProps } from '@material-ui/core/OverridableComponent';
import React, { CSSProperties, HTMLAttributes } from 'react';

export const ImageVariantMap = {
    original: 'file_path',
    thumbnail: 'thumbnail_path, file_path',
    '1000': 'image_1000, file_path',
    '400': 'image_400, thumbnail_path, file_path',
    '200': 'image_200, thumbnail_path, file_path',
    '40': 'image_40, thumbnail_path, file_path',
};

export type ImageVariants = keyof typeof ImageVariantMap;

export interface ImageTypeMap<P = Record<string, any>, D extends React.ElementType = 'div'> {
    props: P & {
        component?: D;
        source: string | Image;
        thumbnail?: string;
        width?: number | string;
        height?: number | string;
        alt?: string;
        variant?: ImageVariants;
        aspectRatio?: number;
        burstCache?: boolean;
        radius?: number | string;
        objectFit?: CSSProperties['objectFit'];
        objectPosition?: CSSProperties['objectPosition'];
        imgProps?: HTMLAttributes<HTMLImageElement> & Record<string, any>;
    };
    defaultComponent: D;
    classKey: ImageClassKey;
}

export type ImageProps<D extends React.ElementType = ImageTypeMap['defaultComponent'], P = Record<string, any>> =
    OverrideProps<ImageTypeMap<P, D>, D>;

export type ImageClassKey = 'root' | 'inner' | 'content' | 'image' | 'imageError' | 'progressHolder' | 'progress';
